module.exports = __webpack_public_path__ + "img/電気回路_1_2_2.81e08258.png";